export const SET_ALL_COUNTRIES = "SET_ALL_COUNTRIES";
export const SET_CREDIT_CARD_LIST = "SET_CREDIT_CARD_LIST";
